import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "reactstrap";
import NeoCard from "../../../../../components/Common/NeoCard";

const DetailUsage = ({ tenant }) => {
    const ef = tenant.effectiveFeatures || {};
    const membersCount = tenant.membersCount || 0;
    const usersCount = tenant.usersCount || 0;
    const maxMembers = ef.maxMembers || "—";
    const maxUsers = ef.maxUsers || "—";

    return (
        <NeoCard
            title="Indicadores e Métricas de Uso do Sistema"
            thinBorder={true}
            bodyClassName="p-4"
        >
            <Row className="g-3 mb-4">
                <Col md={3} xs={6}>
                    <div className="p-3 bg-light rounded text-center border">
                        <span className="text-xs text-muted d-block">Alunos Cadastrados</span>
                        <span className="fs-3 fw-bold text-dark">{membersCount.toLocaleString("pt-BR")}</span>
                        <span className="text-xs text-muted d-block mt-1">Limite: {maxMembers}</span>
                    </div>
                </Col>
                <Col md={3} xs={6}>
                    <div className="p-3 bg-light rounded text-center border">
                        <span className="text-xs text-muted d-block">Usuários Ativos</span>
                        <span className="fs-3 fw-bold text-dark">{usersCount}</span>
                        <span className="text-xs text-muted d-block mt-1">Limite: {maxUsers}</span>
                    </div>
                </Col>
                <Col md={3} xs={6}>
                    <div className="p-3 bg-light rounded text-center border">
                        <span className="text-xs text-muted d-block">Presenças Lançadas</span>
                        <span className="fs-3 fw-bold text-muted">—</span>
                        <span className="text-xs text-muted d-block mt-1">Em breve</span>
                    </div>
                </Col>
                <Col md={3} xs={6}>
                    <div className="p-3 bg-light rounded text-center border">
                        <span className="text-xs text-muted d-block">Avaliações Feitas</span>
                        <span className="fs-3 fw-bold text-muted">—</span>
                        <span className="text-xs text-muted d-block mt-1">Em breve</span>
                    </div>
                </Col>
            </Row>
            <hr />
            <h6 className="fw-bold text-dark mt-3 mb-3">Informações Adicionais</h6>
            <div className="p-3 rounded bg-light border d-flex align-items-center gap-3">
                <i className="ph-light ph-info fs-2 text-muted" />
                <div>
                    <span className="fw-bold d-block text-dark">Métricas detalhadas em breve</span>
                    <span className="text-xs text-muted">
                        As métricas de presenças, avaliações e risco de cancelamento serão disponibilizadas em uma atualização futura.
                    </span>
                </div>
            </div>
        </NeoCard>
    );
};

DetailUsage.propTypes = {
    tenant: PropTypes.object.isRequired
};

export default DetailUsage;
